var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('print-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeKey===1),expression:"activeKey===1"}],ref:"list",on:{"config":_vm.config}}),_c('print-config',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeKey===2),expression:"activeKey===2"}],ref:"configs",on:{"back":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }